export const PMS_USER_ACTION_TYPES = {
    USER_CHANGE_FILTER: "USER_CHANGE_FILTER",
}